export default {
    namespaced: true,

    state: {
        active: false,
        color: '',
        text: '',
    },

    getters: {
        active(state) {
            return state.active;
        },

        color(state) {
            return state.color;
        },

        text(state) {
            return state.text;
        },
    },

    mutations: {
        setActive(state, value) {
            state.active = value.active;
        },

        toggle(state, value) {
            state.active = value.active;
            state.color = value.color;
            state.text = value.text;
        },
    },
    actions: {
        show({ commit, dispatch }, value) {
            commit('toggle', value);
            dispatch('hide');
        },

        hide({ commit }) {
            setTimeout(() => {
                const value = {
                    active: false,
                    color: '',
                    text: '',
                };

                commit('toggle', value);
            }, 3000);
        },
    },
};
